import Button from "../../components/Button"


export default function ValsListFilterBlock(props: any) {

    const {catFeatObj, filterObj, setFilterObj, setQueryObj} = props


    function handleChange(value: string, name: string) {

        setFilterObj((prevState:any) => {
            return {...prevState, [name as keyof typeof prevState]: value}
        })
    }

    function handleClick(event: any) {
        // window.history.replaceState(null, '', `/prj/${queryObj.projID}/cats/1`)

        if (event.target.name === 'Search' || event.key === 'Enter') {
            setQueryObj((prevState: any) => {
                return {...prevState, filterObj: filterObj, currentPage: 1}
            })
        } else {
            for (let k in filterObj) {
                filterObj[k as keyof typeof filterObj] = ''
            }
            setQueryObj((prevState: any) => {
                return {...prevState, filterObj: filterObj, currentPage: 1}
            })
        }
    }


    return (
        <div className="filter-base-container val-grid-filter">

            <div className="trg-subcont">
                <div className="field-label">Tax Type</div>
                <input
                    name="taxType"
                    type="text"
                    className="filter-input"
                    value={catFeatObj.taxType || ''}
                    disabled
                />
            </div>

            <div className="trg-subcont">
                <div className="field-label">Tax Name</div>
                <input
                    name="taxName"
                    type="text"
                    className="filter-input"
                    value={catFeatObj.taxName || ''}
                    disabled
                />
            </div>

            {/*<div className="trg-subcont">*/}
            {/*    <div className="field-label">Category ID</div>*/}
            {/*    <input*/}
            {/*        name="catID"*/}
            {/*        type="text"*/}
            {/*        className="filter-input"*/}
            {/*        value={catFeatObj.catID || ''}*/}
            {/*        disabled*/}
            {/*    />*/}
            {/*</div>*/}

            <div className="trg-subcont">
                <div className="field-label">Category Name</div>
                <input
                    name="catName"
                    type="text"
                    className="filter-input"
                    value={catFeatObj.catName || ''}
                    disabled
                />
            </div>

            {/*<div className="trg-subcont">*/}
            {/*    <div className="field-label">Feature ID</div>*/}
            {/*    <input*/}
            {/*        name="featID"*/}
            {/*        type="text"*/}
            {/*        className="filter-input"*/}
            {/*        value={catFeatObj.features?.featID || ''}*/}
            {/*        disabled*/}
            {/*    />*/}
            {/*</div>*/}

            <div className="trg-subcont">
                <div className="field-label">Feature Name</div>
                <input
                    name="featName"
                    type="text"
                    className="filter-input"
                    value={catFeatObj.features?.featName || ''}
                    disabled
                />
            </div>

            <div className="trg-subcont">
                <div className="field-label">Value Name</div>
                <input
                    name="valName"
                    type="text"
                    className="filter-input"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    // value={filterObj.filterFeatName}
                    value={filterObj.valName}
                />
            </div>

            <div className="trg-subcont">
                <div className="field-label">Status</div>
                <select
                    name="mapStatus"
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                    value={filterObj.mapStatus}
                    disabled={catFeatObj.taxType === 'source'}
                >
                    <option value=""></option>
                    <option value="mapped">mapped</option>
                    <option value="not mapped">not mapped</option>
                    <option value="parked">parked</option>
                </select>
            </div>


            <div className="btn-container">
                {/*<Button type="primary" text="Search" onclick={handleClick}/>*/}
                <Button type="primary" text="Search" onclick={(event:any) => handleClick(event)} />
            </div>

            <div className="btn-container">
                <Button type="secondary" text="Clear" onclick={(event:any) => handleClick(event)} />
            </div>


        </div>
    )

}